function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 2.34375C6.90002 2.34375 2.34375 6.90002 2.34375 12.5C2.34375 18.1 6.90002 22.6562 12.5 22.6562C18.1 22.6562 22.6562 18.1 22.6562 12.5C22.6562 6.90002 18.1 2.34375 12.5 2.34375ZM12.5 3.90625C17.2546 3.90625 21.0938 7.74536 21.0938 12.5C21.0938 17.2546 17.2546 21.0938 12.5 21.0938C7.74536 21.0938 3.90625 17.2546 3.90625 12.5C3.90625 7.74536 7.74536 3.90625 12.5 3.90625ZM11.7188 7.8125V9.375H13.2812V7.8125H11.7188ZM11.7188 10.9375V17.1875H13.2812V10.9375H11.7188Z",
  fill: "url(#paint950_linear_1281:3)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint950_linear_1281:3",
  x1: 2.89462,
  y1: 25.3286,
  x2: 23.2876,
  y2: 3.22125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})));

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.aafea1f5.svg";
export { ForwardRef as ReactComponent };